<template>
  <div class="page">
    <div class="header">
      <div class="description">
        <h1 class="title">Nova Consulta</h1>
      </div>
    </div>

    <new-query
      tag="cnpj"
      consultations-route="/compliance/legal-person"
    />
  </div>
</template>

<script>
import NewQuery from '@/compliance/components/NewQuery.vue';

export default {
  name: 'Create',

  components: {
    NewQuery,
  },
};
</script>

<style lang="scss" scoped>

</style>
